<template>
  <ds-card class="nx-login-form">
    <div class="text-xs-center nx-brand--text">
      <nx-bcube-logo
        brand
        width="135px"
      />
    </div>

    <ds-heading size="500" class="text-xs-center">
      {{ title }}
    </ds-heading>

    <div class="nx-login-form__content">
      <slot />
    </div>

    <nx-auth-alternative-login-methods-drawer
      v-if="loginMethod"
      :current-login-method="loginMethod"
      v-on="$listeners"
    />
  </ds-card>
</template>

<script>
import NxBcubeLogo from '@/components/icons/BcubeLogo.vue';
import NxAuthAlternativeLoginMethodsDrawer
  from '@/modules/authentication/components/alternative-login-methods/AuthAlternativeLoginMethodsDrawer.vue';

export default {
  name: 'NxAuthCard',
  components: {
    NxBcubeLogo,
    NxAuthAlternativeLoginMethodsDrawer,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    loginMethod: {
      type: String,
      default: undefined,
    },
  },
};
</script>

<style lang="stylus">
@import '../../../assets/stylus/variables.styl';

.nx-login-form {
  width: 400px;

  &--configure-second-factor {
    width: 600px;
  }

  &__content,
  &__content .nx-form {
    display: flex;
    flex-direction: column;
    gap: 24px;

  }

  h3 {

  }

  p {
    margin-bottom: 0
  }

  .v-btn--block {
    margin: 0
    flex-basis: auto;
  }
}
</style>
